module.exports = __webpack_public_path__ + "static/media/cancer_chat_white.5789057e.png";